import { countries } from "country-data";

function findCountryByCode(code) {
  const normalized = String(code || "").trim().toUpperCase();
  if (!normalized) return null;

  if (normalized.length === 2) {
    return countries[normalized] || null;
  }

  if (normalized.length === 3) {
    return (
      countries.all.find(
        (country) =>
          country.status === "assigned" &&
          country.alpha3?.toUpperCase() === normalized,
      ) || null
    );
  }

  return null;
}

export function alpha3ToAlpha2(code) {
  const country = findCountryByCode(code);
  return country?.alpha2?.toUpperCase() || "";
}

export function normalizeCountryCodeToAlpha2(code) {
  const normalized = String(code || "").trim().toUpperCase();
  if (!normalized) return "";

  if (normalized.length === 2) {
    return countries[normalized] ? normalized : "";
  }

  return alpha3ToAlpha2(normalized);
}
